import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const positionsService = {
  getPositions: async () => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/positions`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    });
    return response.json();
  },

  updatePositions: async (positions) => {
    const sessionToken = getCookie();
    if (!sessionToken) return handleSessionExpire();

    const response = await fetch(`${API_URL}/updatePositions`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
      body: JSON.stringify(positions),
    });
    return response.json();
  },
};

export default positionsService;
